export default "__VITE_ASSET__8409df72__"